module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-slide-1-133b86b7f0de754cd03903d821a9db20.png";